<template>
  <div class="mb-6">

    <div class="columns is-multiline">
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Stato"
          v-model="filters.status"
          :options="['Concluso', 'Annullato', 'Da completare', 'Non conclusi']"
          @select="onFilterInput"
          @remove="onFilterInput"
        />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Situazione mancante 2"
          v-model="filters.special"
          :options="specials"
          id="value"
          track-by="value"
          label="value"
          @select="onFilterInput"
          @remove="onFilterInput"
        >
        <template #option="props">
          <div :class="'label-special ' + props.option.color"></div>
        </template>
        <template #singleLabel="props">
          <div :class="'label-special ' + props.option.color"></div>
        </template>
        </InputSelect>
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Occupante"
          v-model="filters.occupant"
          :options="clients"
          :loading="waitClients"
          :disabled="waitClients"
          id="_id"
          track-by="_id"
          :custom-label="$clientName"
          @select="filterOccupant"
          @remove="filterOccupant(false)"
        />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Proprietario"
          v-model="filters.client"
          :options="clients"
          :loading="waitClients"
          :disabled="waitClients"
          id="_id"
          track-by="_id"
          :custom-label="$clientName"
          @select="filterClient"
          @remove="filterClient(false)"
        />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Luogo" v-model="filters.place" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Impianto" v-model="filters.implant" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Installatore" v-model="filters.installer" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <div class="field">
          <label class="label">Intervallo date</label>
          <InputDate v-model="filters.range" @update="onFilterInput" placeholder="Intervallo date" :range="true" :showIcon="true" />
        </div>
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Tipologia"
          v-model="filters.type"
          :options="$store.state.operation_types"
          id="name"
          track-by="name"
          label="name"
          @select="onFilterInput"
          @remove="onFilterInput"
        />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <div class="field">
          <label class="label" for="filterMaintenance">Manutenzioni</label>
          <div class="control is-flex">
            <label class="checkbox">
              <input type="checkbox" id="filterMaintenance" v-model="filters.maintenance" @change="onFilterInput">
            </label>
          </div>
        </div>
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Collaboratore"
          v-model="filters.operator"
          :options="$store.getters.operatorsFilter"
          id="_id"
          track-by="_id"
          :custom-label="$fullname"
          @select="filterOperators"
          @remove="filterOperators(false)"
        />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Progressivo" v-model="filters.progressive" @input="onFilterInput" type="number" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Situazione mancante"
          v-model="filters.situation"
          :options="situations"
          id="value"
          track-by="value"
          label="key"
          multiple
          @select="onFilterInput"
          @remove="onFilterInput"
        />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Ricevuta"
          v-model="filters.receiptType"
          :options="receiptTypes"
          id="value"
          track-by="value"
          label="key"
          @select="onFilterInput"
          @remove="onFilterInput"
        />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <div class="field">
          <label class="label" for="filterInvoiced">Solo fatturati</label>
          <div class="control is-flex">
            <label class="checkbox">
              <input type="checkbox" id="filterInvoiced" v-model="filters.invoiced" @change="onFilterInput">
            </label>
          </div>
        </div>
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Numero Fattura" v-model="filters.invoice_number" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <div class="field">
          <label class="label" for="filterHasMaterials">Con materiale</label>
          <div class="control is-flex">
            <label class="checkbox">
              <input type="checkbox" id="filterHasMaterials" v-model="filters.hasMaterials" @change="onFilterInput">
            </label>
          </div>
        </div>
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <div class="field">
          <label class="label" for="filterException">Eccezione</label>
          <div class="control is-flex">
            <label class="checkbox">
              <input type="checkbox" id="filterException" v-model="filters.exception" @change="onFilterInput">
            </label>
          </div>
        </div>
      </div>
      <div class="column is-12-mobile is-2-tablet">
        <InputText :hasIconSearch="true" name="Note" v-model="filters.notes" @input="onFilterInput" />
      </div>
      <div class="column is-12-mobile is-4-tablet">
        <label class="label">&nbsp;</label>
        <div class="buttons is-flex">
          <button class="button" @click="resetFilters()"><font-awesome-icon icon="filter-circle-xmark" />Reset</button>
          <button class="button is-warning" @click="openBulkSituationModal()" :disabled="selectedOperations.length === 0"><font-awesome-icon icon="pen-to-square" />Modifica situazione</button>
          <router-link to="/appuntamenti/new" class="button is-primary is-hidden-touch" @click="resetFilters()"><font-awesome-icon icon="plus" />Aggiungi</router-link>
        </div>
      </div>
    </div>

    <div class="b-table has-pagination" :class="{'is-loading': loading}">
      <div class="table-wrapper has-mobile-cards">
        <table class="table is-fullwidth is-striped is-hoverable">
          <thead>
          <tr>
            <th style="width: 24px;">
              <label class="checkbox">
                <input type="checkbox" v-model="selectAllValue" @change="selectAll()">
              </label>
            </th>
            <th style="width: 24px;" v-if="isSelection"></th>
            <th style="width: 24px;"></th>
            <th><div>Occupante</div><div><small class="has-text-grey is-abbr-like">Proprietario</small></div></th>
            <th>Luogo</th>
            <th>Impianto</th>
            <th>Data</th>
            <th>Tipologia</th>
            <th>Collaboratore</th>
            <th>Prog.</th>
            <th>Ricambi</th>
            <!--<th>Prezzo</th>-->
            <th>Situazione</th>
            <th>Note</th>
            <th style="min-width: 100px;"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(operation, index) in operations" :key="index">
            <td>
              <label class="checkbox">
                <input type="checkbox" v-model="operation.selected" @change="syncSelectAll()">
              </label>
            </td>
            <td v-if="isSelection">
              <label class="radio">
                <input type="radio" :value="operation" v-model="selectedOperation" @change="() => $emit('selected', selectedOperation)">
              </label>
            </td>
            <td :class="getStatus(operation)" :title="operation.status" style="position: relative;">
              <div v-if="operation.special2" class="op-status-special2"></div>
            </td>
            <td data-label="Occupante">
              <router-link v-if="operation.occupant" :to="'/clienti/' + operation.occupant._id">
                <ClientHeading :client="operation.occupant" />
              </router-link>
              <router-link v-if="operation.client" :to="'/clienti/' + operation.client._id">
                <ClientHeading :client="operation.client" :owner="true" />
              </router-link>
            </td>
            <td data-label="Luogo">
              <router-link v-if="operation.place" :to="'/luoghi/' + operation.place._id">
                <AddressDisplay :value="operation.place" />
              </router-link>
            </td>
            <td data-label="Impianto">
              <router-link v-if="operation.implant" :to="'/impianti/' + operation.implant._id" style="white-space: pre-line">
                <div v-if="operation.implantCode">
                  <small class="has-text-grey is-abbr-like" :title="$fulladdress(operation.place)">
                    {{ operation.implantCode }}
                  </small>
                </div>
                <div v-if="operation.implantCode">
                  {{$implantNameOperation(operation)}}
                </div>
                <div v-else>
                  {{$implantName(operation.implant)}}
                </div>

                <div class="tags" v-if="calcTypes(operation.implant, operation.implantCode, operation.implantGenerators)?.length">
                  <span class="tag is-dark" v-for="(type, index) in calcTypes(operation.implant, operation.implantCode, operation.implantGenerators)" :key="index">{{ type }}</span>
                </div>
              </router-link>
              <div class="has-text-grey" v-if="getInstallers(operation)">
                <small>Installatore: {{ getInstallers(operation) }}</small>
              </div>
            </td>
            <td data-label="Data">
              <div v-if="operation.appointment_date">{{new Date(operation.appointment_date).toDisplay()}}</div>
              <div v-if="operation.appointment_start || operation.appointment_end"><small class="has-text-grey is-abbr-like"><span>{{operation.appointment_start}}</span>-<span>{{operation.appointment_end}}</span></small></div>
            </td>
            <td data-label="Tipologia">
              {{operation.type}}
            </td>
            <td data-label="Collaboratore">
              <div class="tags">
                <span :class="'tag is-info ' + (operator.color ? operator.color + '-card' : '')" v-for="(operator, index) in operation.operators" :key="index">{{$fullname(operator)}}</span>
              </div>
            </td>
            <td data-label="Progressivo">
              {{ operation.progressive }}
            </td>
            <td data-label="Ricambi">
              <span v-if="(operation.spare_parts?.total || 0) > 0" class="tag is-warning">
                Qta {{ operation.spare_parts?.total || 0 }}
              </span>
            </td>
            <!--<td data-label="Prezzo">
              {{ operation.price }}
            </td>-->
            <td data-label="Situazione">
              <div class="tags" style="max-width: 220px;">
                <span class="tag is-danger" v-if="!operation.confirmed">Da confermare</span>
                <span class="tag is-success" v-if="operation.confirmed">Confermato</span>
                <span class="tag is-danger" v-if="/*hasDocumentation(operation) && */operation.missing_documentation">Doc. mancante</span>
                <span class="tag is-dark" v-if="operation.receipt">Scontrino</span>
                <span class="tag is-danger" v-if="operation.to_invoice && !operation.invoiced">Da fatturare</span>
                <span class="tag is-success" v-if="operation.invoiced">Fatturato{{ operation.invoice_number ? ' #' + operation.invoice_number : '' }}</span>
                <span class="tag is-success" :class="{'is-success': operation.paid, 'is-danger': !operation.paid}">Pagato</span>
                <span class="tag is-info" v-if="operation.no_due">Non deve nulla</span>
                <span class="tag is-danger" v-if="operation.to_fgas && !operation.fgas">Fare Fgas</span>
                <span class="tag is-success" v-if="operation.fgas">Fgas</span>
                <span class="tag is-danger" v-if="operation.to_curmit && !operation.curmit">Fare Curmit</span>
                <span class="tag is-success" v-if="operation.curmit">Curmit</span>
                <span class="tag is-primary" v-if="operation.exception">Eccezione</span>
                <span class="tag" :class="{'is-success': operation.controlled, 'is-danger': !operation.controlled}">Controllato</span>
              </div>
            </td>
            <td data-label="Note">
              <div class="field has-addons">
                <p class="control">
                  <InfoButton :text="operation.notes_office" title="Motivo intervento" />
                </p>
                <p class="control">
                  <InfoButton :text="operation.notes" title="Note tecnico" />
                </p>
              </div>
            </td>
            <td class="is-actions-cell is-justify-content-flex-end">
              <div class="buttons is-right">
                <!--<button v-if="operation.status === 'Da completare' && !operation.linked_operation_next" class="button is-danger" @click="openLinkOperationModal(operation)" title="Crea appuntamento">
                  <span class="icon"><font-awesome-icon icon="plus" /></span>
                </button>
                <router-link v-if="operation.linked_operation_next" :to="'/appuntamenti/' + operation.linked_operation_next" class="button is-success has-tooltip-arrow has-tooltip-multiline" data-tooltip="Appuntamento successivo">
                  <font-awesome-icon icon="file-lines" class="m-0" />
                </router-link>-->
                <router-link :to="'/appuntamenti/' + operation._id" class="button is-warning" type="button" title="Modifica" :disabled="operation.waitDelete">
                  <span class="icon"><font-awesome-icon icon="pen" /></span>
                </router-link>
                <button class="button is-danger" type="button" @click="deleteOperation(operation)" title="Elimina" :class="[{'is-loading': operation.waitDelete}]" :disabled="operation.waitDelete">
                  <span class="icon"><font-awesome-icon icon="trash-can" /></span>
                </button>
              </div>
            </td>
          </tr>
          <tr v-if="operations.length === 0">
            <td colspan="100" class="has-text-centered has-text-grey">
              <i>Nessun risultato</i>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <Pagination :pagination="pagination" @change="getOperations($event)" />
    </div>

    <router-link v-if="$store.getters.amAdmin" to="/appuntamenti/new" class="button is-floating is-primary is-hidden-desktop" title="Nuovo">
      <span class="icon">
        <font-awesome-icon icon="plus" />
      </span>
    </router-link>

    <OperationBulkSituationModal
      ref="bulkSituationModal"
      :selectedOperations="selectedOperations"
      @saved="onBulkSituationSaved()"
    />

    <!--<AppointmentLinkCalendar :originalAppointment="toLinkOperation" :open="openLinkModal" @close="this.openLinkModal = false" @saved="saveLinkOperation($event)" />-->

  </div>
</template>

<script>
import utils from '../utils'
import AddressDisplay from '../components/AddressDisplay.vue'
import OperationBulkSituationModal from '../components/OperationBulkSituationModal.vue'

export default {
  components: {
    AddressDisplay,
    OperationBulkSituationModal
  },

  props: {
    isSelection: {
      type: Boolean,
      default: false
    }
  },

  emits: ['selected'],

  data() {
    return {
      filters: this.$store.state.filters.operationTable,

      clients: [],

      operations: [],

      pagination:{
        total: false,
        selected: false
      },

      loading: true,
      waitClients: true,

      receiptTypes: [
        {
          key: 'Scontrino',
          value: 'receipt'
        },
        {
          key: 'Da fatturare',
          value: 'to_invoice'
        }
      ],

      situations: [
        {
          key: 'Confermato',
          value: 'confirmed'
        },
        {
          key: 'Doc. mancante',
          value: 'missing_documentation'
        },
        {
          key: 'Fatturato',
          value: 'invoiced'
        },
        {
          key: 'Pagato',
          value: 'paid'
        },
        {
          key: 'Fgas',
          value: 'fgas'
        },
        {
          key: 'Curmit',
          value: 'curmit'
        },
        {
          key: 'Controllato',
          value: 'controlled'
        }
      ],

      specials: [
      {
          value: 'special',
          color: 'pink'
        },
        {
          value: 'special2',
          color: 'red'
        }
      ],

      //openLinkModal: false,
      //toLinkOperation: false
      selectedOperation: null,

      selectAllValue: false
    }
  },

  computed: {
    selectedOperations() {
      return this.operations.filter(operation => !!operation.selected)
    }
  },

  methods: {
    selectAll() {
      this.operations.forEach(operation => {
        operation.selected = this.selectAllValue
      })
    },

    syncSelectAll() {
      if (!this.operations.length) {
        this.selectAllValue = false
        return
      }

      this.selectAllValue = this.operations.every(operation => !!operation.selected)
    },

    openBulkSituationModal() {
      this.$refs.bulkSituationModal?.open()
    },

    onBulkSituationSaved() {
      this.selectAllValue = false
      this.getOperations({page: this.$store.state.pages.operation.number, size: this.$store.state.pages.operation.size})
    },

    filterOperators(selected) {
      this.filters.operator = selected
      this.getOperations()
    },

    resetFilters() {
      this.filters = {
        range: {start: utils.getBefore30Day(), end: utils.getAfter30Day()}
      }

      this.getOperations()
    },

    filterOccupant(selected) {
      this.filters.occupant = selected
      this.getOperations()
    },

    filterClient(selected) {
      this.filters.client = selected
      this.getOperations()
    },

    getOperations(args = {page: 1, size: 30, scroll: 0}) {
      const self = this

      this.loading = true

      this.$store.commit('setFilter', {name: 'operationTable', value: this.filters})
      this.$store.commit('setPage', {name: 'operation', value: {number: args.page, size: args.size}})

      const notClosed = this.filters.status === 'Non conclusi'
      const status = notClosed ? null : this.filters.status
      const special = this.filters.special ? this.filters.special.value : null
      const occupantId = this.filters.occupant ? this.filters.occupant._id : null
      const clientId = this.filters.client ? this.filters.client._id : null
      const place = this.filters.place
      const implant = this.filters.implant
      const installer = this.filters.installer
      const startDate = this.filters.range.start.toDateInputValue()
      const endDate = this.filters.range.end.toDateInputValue()
      const type = this.filters.type ? this.filters.type.name : null
      const maintenance = this.filters.maintenance
      const operator = this.filters.operator ? this.filters.operator._id : null
      const progressive = this.filters.progressive
      const invoiceNumber = this.filters.invoice_number
      const situation = []
      if (this.filters.situation) {
        this.filters.situation.forEach(sit => {
          situation.push(sit.value)
        })
      }
      const receiptType = this.filters.receiptType ? this.filters.receiptType.value : null
      const invoiced = this.filters.invoiced
      const hasMaterials = this.filters.hasMaterials
      const exception = this.filters.exception
      const notes = this.filters.notes

      this.$http.get('/operation', { params: {
        page: args.page,
        size: args.size,
        status,
        notClosed,
        special,
        occupant: occupantId,
        client: clientId,
        place,
        implant,
        installer,
        startDate,
        endDate,
        type,
        maintenance,
        operator,
        progressive,
        invoiceNumber,
        situation,
        receiptType,
        invoiced,
        hasMaterials,
        exception,
        notes
      } }).then(response => {
        if (response && response.data) {
          this.operations = response.data.records
          this.selectAllValue = false
          this.pagination = {
            total: response.data.totalRecords,
            pages: response.data.totalPages,
            selected: response.data.currentPage
          }

          if (args.scroll) {
            self.$nextTick(() => {
              window.scroll(0, args.scroll)
            })
          }
        }

        this.loading = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.loading = false
      })
    },

    deleteOperation(operation) {
      if (confirm('Eliminare?')) {
        const self = this
        operation.waitDelete = true

        this.$http.delete('/operation/' + operation._id)
        .then(function (response) {
          self.getOperations({page: self.$store.state.pages.operation.number, size: self.$store.state.pages.operation.size})
        })
        .catch(function (error) {
          console.log(error)
          alert('Errore')
          operation.waitDelete = false
        })
      }
    },

    getStatus(operation) {
      let result = ''

      if (operation.status === 'Concluso') {
        result = 'op-status-closed'
      } else if (operation.status === 'Annullato') {
        result = 'op-status-cancel'
      } else if (operation.status === 'Da completare') {
        result = 'op-status-waiting'
      }

      if (operation.special) {
        result += ' op-status-special'
      }

      return result
    },

    /*hasDocumentation(operation) {
      if (operation.type) {
        const found = this.$store.state.operation_types.find(ot => ot.name === operation.type && ot.documentation)

        return found
      }

      return false
    },*/

    calcTypes(implant, implantCode, implantGenerators) {
      if (implant) {
        return utils.calcTypes(implant, implantCode, implantGenerators)
      } else {
        return []
      }
    },

    /*openLinkOperationModal(operation) {
      this.openLinkModal = true
      this.toLinkOperation = operation
    },*/

    /*saveLinkOperation() {
      this.openLinkModal = false
      this.toLinkOperation = false
      this.getOperations({page: this.$store.state.pages.operation.number, size: this.$store.state.pages.operation.size})
    }*/

    getInstallers(operation) {
      if (operation.implant) {
        const gens = utils.getGenerators(operation.implant)
        return utils.getInstallers(gens)
      } else {
        return null
      }
    }
  },

  mounted() {
    const self = this

    this.$http.get('/client/filter')
    .then(function (response) {
      self.clients = response.data

      self.waitClients = false
    })
    .catch(function (error) {
      console.log(error)
      alert('Errore')
    })

    this.getOperations({page: this.$store.state.pages.operation.number, size: this.$store.state.pages.operation.size, scroll: this.$store.state.pages.operation.scroll})
  },

  created() {
    this.onFilterInput = this.$debounce(() => this.getOperations(), 500)
  },

  beforeUnmount() {
    const scroll = window.top.scrollY
    let page = Object.assign({}, this.$store.state.pages.operation)
    page.scroll = scroll
    this.$store.commit('setPage', {name: 'operation', value: page})
  }
}
</script>